import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Header, Input, Segment, Tab } from 'semantic-ui-react';
import { setFileStatus } from '../../actions/support';
import FilePreview from '../identity/FilePreview';

const FilePane = ({ file, setFileStatus }) => {
  const [rejectionReason, setRejectionReason] = useState('');

  if (!file) {
    return (
      <Segment>
        <Header textAlign='center' size='small'>
          File not uploaded
        </Header>
      </Segment>
    );
  }

  const { status, code, hash } = file;

  const handleAccept = () => setFileStatus(code, 'accepted', hash);
  const handleReject = () => setFileStatus(code, 'rejected', hash, rejectionReason);
  const handleChange = (e, { value }) => setRejectionReason(value);

  const isVerified = () => status === 'accepted' || status === 'rejected';

  return (
    <Tab.Pane>
      <Segment basic style={{ padding: 0, margin: 0 }} className='flexbox-centered'>
        <FilePreview currentFile={file} />
        {!isVerified() && (
          <Segment basic className='flexbox-spaced-between' style={{ padding: 0, width: '100%' }}>
            <Form onSubmit={handleReject}>
              <Input
                required
                type='text'
                placeholder='Rejection reason'
                style={{ width: '320px' }}
                value={rejectionReason}
                onChange={handleChange}
              />
              <Button type='submit' color='red' style={{ margin: '0 1rem' }}>
                REJECT
              </Button>
            </Form>
            <Button positive onClick={handleAccept}>
              ACCEPT
            </Button>
          </Segment>
        )}
      </Segment>
    </Tab.Pane>
  );
};

export default connect(null, { setFileStatus })(FilePane);
